// Vendor imports
const { createSelector } = require('reselect')

module.exports = {
  createFeedSelectors,
  defaultFeedSelectors: createFeedSelectors('feed')
}

function createFeedSelectors(stateKey) {

  function getStream(state) {
    return state.get(stateKey)
  }

  const getItems = createSelector(
    getStream,
    stream => stream.items
  )

  const getMeta = createSelector(
    getStream,
    stream => stream.meta
  )

  const getIsNextPageAvailable = createSelector(
    getStream,
    stream => stream.isNextPageAvailable
  )

  const getIsNextPageLoading = createSelector(
    getStream,
    stream => stream.isNextPageLoading
  )

  const getNextPageUrl = createSelector(
    getStream,
    stream => stream.nextPageUrl
  )

  const getTitle = createSelector(
    getMeta,
    meta => meta.title
  )

  // Memoize to prevent unnecessary updates
  // https://github.com/reduxjs/reselect#motivation-for-memoized-selectors
  const getDenormalizedItems = createSelector(
    getStream,
    stream => stream.getDenormalizedItems()
  )

  return {
    getDenormalizedItems,
    getIsNextPageAvailable,
    getIsNextPageLoading,
    getItems,
    getMeta,
    getNextPageUrl,
    getStream,
    getTitle
  }
}
